<template>
  <div>
    <v-layout class="px-4" row wrap justify-space-between>
      <v-flex>
        <v-btn color="primary" dark @click.stop="resetFilters">Reset filters</v-btn>
      </v-flex>
      <v-spacer />
      <v-flex xs2 class="px-4">
        <content-field
          label="Search by company"
          v-model="filter.searchByCompany"
        />
      </v-flex>
      <v-flex xs2 class="px-4">
        <content-field
          label="Search by name"
          v-model="filter.searchByName"
        />
      </v-flex>
      <v-flex xs2 class="px-4">
        <v-select
          :items="listOfStatus"
          v-model="filter.filterByStatus"
          item-value="id"
          item-text="name"
          label="Status"
        />
      </v-flex>
      <v-flex xs2 class="px-4">
        <v-select
          :items="testimonialTypesListForDisplay"
          v-model="filter.filterByType"
          item-value="id"
          item-text="name"
          label="Type"
        />
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="listOfTestimonials"
      :headers="headers"
      :items="listOfTestimonials"
      class="elevation-1 wrap"
      :pagination.sync="pagination"
      :total-items="totalItemsInTable"
      :loading="loading"
      item-key="id"
      :disable-initial-sort="true"
    >
      <template slot="items" slot-scope="props">
        <td class="py-2">{{props.item.employeeName}}</td>
        <td class="py-2">{{props.item.companyName}}</td>
        <td class="py-2">{{props.item.jobTitle}}</td>
        <td class="py-2">
          {{ getTextFromHTMLStr(path([props.item.testimonialTypeId, 'name'], mapOfTestimonialTypes)) }}
        </td>
        <td class="py-2" v-if="props.item.id">
          {{showCategoryTestimonial(props.item)}}
        </td>
        <td class="py-2">{{props.item.status}}</td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="blue darken-4"
              fab flat
              slot="activator"
              @click.stop="changeStatusTestimonial(props.item)"
            >
              <v-icon>swap_horiz</v-icon>
            </v-btn>
            <span>Change status</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="success"
              fab flat
              slot="activator"
              @click.stop="editTestimonial(props.item)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="error"
              fab flat
              slot="activator"
              @click.stop="deleteTestimonial(props.item.id)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="pageText" slot-scope="{}">
        Page {{pagination.page}} of {{totalPagesLYTestimonials}}
      </template>
    </v-data-table>
    <v-dialog persistent v-model="isStatusReminderVisible" max-width="500px">
      <v-card>
        <v-card-title>
          <h3>Reminder: </h3>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <p>
            You've just changed Testimonial's status. Don't forget to update the display settings!
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" flat @click="hideChangeStatusReminder">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContentField from '@/components/shared/ContentField/index.vue'
import debounce from 'lodash.debounce'
import { equals, path, isNil, propEq, clone } from 'ramda'
import { timeSettings } from '@/modules/settings/'
import getTextFromHTMLStr from '@/utils/getTextFromHTMLStr'

export default {
  name: 'TableOfTestimonials',
  components: {
    ContentField
  },
  data () {
    return {
      isStatusReminderVisible: false,
      pagination: {
        rowsPerPage: 5
      },
      loading: false,
      filter: {
        filterByStatus: '',
        filterByType: '',
        searchByCompany: '',
        searchByName: ''
      },
      listOfTestimonials: [],
      listOfStatus: [
        {
          id: 'Draft',
          name: 'Draft'
        },
        {
          id: 'Published',
          name: 'Published'
        },
        {
          id: '',
          name: 'All'
        }
      ],
      filterInput: '',
      mapOfTestimonialTypes: null,
      headers: [
        { text: 'Name', value: 'employeeName', search: true, sortable: true, width: 100 },
        { text: 'Company', value: 'companyName', search: false, sortable: true, width: 100 },
        { text: 'Job title', value: 'jobTitle', search: false, sortable: true, width: 100 },
        { text: 'Type', value: 'testimonialTypeId', search: false, sortable: true, width: 100 },
        { text: 'Testimonial category', search: false, sortable: false, width: 100},
        { text: 'Status', value: 'status', search: false, sortable: true, width: 100 },
        { text: 'Change status', search: false, sortable: false, align: 'center', width: 50 },
        { text: 'Edit', search: false, sortable: false, align: 'center', width: 50 },
        { text: 'Delete', search: false, sortable: false, align: 'center', width: 50 }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'lastYearTestimonialsList',
      'totalPagesLYTestimonials',
      'totalItemsLYTestimonials',
      'testimonialTypesList'
    ]),
    testimonialTypesListForDisplay () {
      if (this.testimonialTypesList) {
        let testimonialTypes = clone(this.testimonialTypesList)
        testimonialTypes.forEach(el => el.name = this.getTextFromHTMLStr(el.name))
        return [...testimonialTypes, { id: '', name: 'All' }]
      } else {
        return []
      }
    },
    totalItemsInTable () {
        return this.totalItemsLYTestimonials || (this.totalPagesLYTestimonials * this.pagination.rowsPerPage)
      }
  },
  watch: {
    pagination: {
      handler () {
        if (!this.loading) {
          this.getLYTestimonialsList()
        }
      },
      deep: true
    },
    filter: {
      handler () {
        this.getLYTestimonialsList()
      },
      deep: true
    },
    lastYearTestimonialsList (val) {
      this.listOfTestimonials = [...val]
    }
  },
  methods: {
    path,
    ...mapActions([
      'fetchLastYearTestimonials',
      'fetchTestimonialTypes',
      'removeLastYearTestimonial',
      'changeLYTestimonialStatus'
    ]),
    getTextFromHTMLStr,
    hideChangeStatusReminder () {
      this.isStatusReminderVisible = false
    },
    showCategoryTestimonial (testimonial) {
      const isVideoTestimonial = !!path(['youtubeVideoCode'], testimonial)
      const category = isVideoTestimonial ? 'Video testimonial' : 'Text testimonial'
      return category
    },
    async changeStatusTestimonial (testimonial) {
      const payload = {
        id: testimonial.id,
        status: testimonial.status === 'Draft' ? 'Published' : 'Draft'
      }
      try {
        await this.changeLYTestimonialStatus(payload)
        this.getLYTestimonialsList()
        this.isStatusReminderVisible = true
      } catch (err) {
        console.error(err)
      }
    },
    async deleteTestimonial (testimonialId) {
      try {
        await this.removeLastYearTestimonial(testimonialId)
        this.getLYTestimonialsList()
      } catch (err) {
        console.error(err)
      }
    },
    resetFilters () {
      this.filter = {
        filterByStatus: '',
        filterByType: '',
        searchByCompany: '',
        searchByName: ''
      }
      this.pagination.sortBy = null
      this.pagination.descending = false
      this.getLYTestimonialsList()
    },
    editTestimonial (testimonial) {
      this.$bus.$emit('onUpdateTestimonial', testimonial)
    },
    getLYTestimonialsList: debounce(async function() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.totalItemsLYTestimonials : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: this.filter,
        sort,
        name
      }
      await this.fetchLastYearTestimonials(getParams)
      this.loading = false
    }, timeSettings.delayTime)
  },
  async mounted () {
    this.getLYTestimonialsList()
    this.$bus.$on('reloadTestimonialsTable', () => this.getLYTestimonialsList())
    this.mapOfTestimonialTypes = this.testimonialTypesList.reduce((acc, curr) => {
      acc[curr.id] = curr
      return acc
    }, {})
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Testimonials/TestimonialsList/tableOfTestimonials.vue